import { ReactComponent as ScreenMockupSVG } from "../../assets/screen-mockup.svg";

export function ScreenMockup() {
  return (
    <ScreenMockupSVG style={{ marginTop: 120, marginLeft: 120, flexGrow: 1 }} />
  );
}
